import ControlModule from 'scripts/poppet/control-module';
import template      from 'templates/controlWarmupStates.jst.html'
import { Vue }       from 'vue/defavue';



export const ControlWarmupStatesView = ControlModule.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template : template,
	expandedNavState  : 'unit:control:warmupStates',
	compressedNavState: 'unit:control:overview',
	

	
	className: function () {
		return this._getClassName( 'control-warmup-states' );
	},
	

	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	onDomRefresh: function () {
		let self = this;
		new Vue( {
			el: '#warmup-state-vue-container',
			bb() {
				return {
					model: self.model,
				}
			},
			computed: {
				warmUpState: function () {
					if(this.model.heatingTimer){
						if('success' === this.model.heatingTimer.status){
							return this.model.heatingTimer.value > 0 ? 'ON' : 'OFF'
						}
						return this.model.heatingTimer.value
					}else{
						return '--'
					}
				},
				warmUpStatus: function () {
					return this.model.heatingTimer ? this.model.heatingTimer.status : ''
				},
				
				powerCableState: function () {
					if(this.model.mainsConnected){
						if('success' === this.model.mainsConnected.status){
							return this.model.mainsConnected.value  ? 'CONNECTED' : 'DISCONNECTED'
						}
						return this.model.mainsConnected.value
					}else{
						return '--'
					}
				},
				
				powerCableStatus: function () {
					return this.model.mainsConnected ? this.model.mainsConnected.status : ''
				},
				
				interiorTemperatureState: function () {
					if(this.model.interiorTemperature){
						if('success' === this.model.interiorTemperature.status){
							return this.model.interiorTemperature.value  ? this.model.interiorTemperature.value + ' ºC' : '--'
						}
						return this.model.interiorTemperature.value
					}else{
						return '--'
					}
				},
				interiorTemperatureStatus: function () {
					return this.model.interiorTemperature ? this.model.interiorTemperature.status : ''
				},
				
				exteriorTemperatureState: function () {
					if(this.model.exteriorTemperature){
						if('success' === this.model.exteriorTemperature.status){
							return this.model.exteriorTemperature.value  ? this.model.exteriorTemperature.value + ' ºC' : '--'
						}
						return this.model.exteriorTemperature.value
					}else{
						return '--'
					}
				},
				exteriorTemperatureStatus: function () {
					return this.model.exteriorTemperature ? this.model.exteriorTemperature.status : ''
				},
				
				
				
			}
		} );
	},
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
});

export default ControlWarmupStatesView;
